module.exports = __webpack_public_path__ + "0b051988807c470f0cc39fc67b5c407c.svg";